<template>
    <div class="bg-white py-16 sm:py-24">
        <Container>
            <SectionHeading eyebrow="Programs" title="Courses to match your needs"
                description="Whether you are a beginner or an advanced learner, we have the right course for you — designed to help you learn Arabic in a fun and engaging way, with experienced teachers and interactive materials." />

            <div class="mx-auto mt-12 grid max-w-2xl grid-cols-1 gap-6 sm:mt-16 sm:grid-cols-2 lg:max-w-none lg:grid-cols-4">
                <router-link v-for="(course, index) in courses" :key="course.id ?? index" :to="`/courses/${course.slug}`"
                    class="group relative isolate flex aspect-3/4 flex-col justify-end overflow-hidden rounded-2xl bg-gray-100 p-6 shadow-sm transition-shadow hover:shadow-xl">
                    <img :src="course.image || fallbackImages[index % fallbackImages.length]" :alt="course.name"
                        class="absolute inset-0 -z-10 size-full object-cover transition-transform duration-500 group-hover:scale-105" />
                    <div class="absolute inset-0 -z-10 bg-gradient-to-t from-gray-950/85 via-gray-950/20 to-transparent" />
                    <h3 class="text-lg font-semibold text-white">{{ course.name }}</h3>
                    <p class="mt-1 text-sm text-gray-200 line-clamp-2">{{ course.description }}</p>
                </router-link>

                <router-link to="/courses"
                    class="group flex aspect-3/4 flex-col items-center justify-center gap-3 rounded-2xl border-2 border-dashed border-gray-200 p-6 text-center transition-colors hover:border-primary-300 hover:bg-primary-50/40">
                    <span class="flex size-12 items-center justify-center rounded-full bg-primary-50 text-primary-600 transition-colors group-hover:bg-primary-100">
                        <ArrowRightIcon class="size-5" />
                    </span>
                    <span class="font-semibold text-gray-900">See all courses</span>
                </router-link>
            </div>
        </Container>
    </div>
</template>

<script setup type="module">
import { onMounted, ref } from 'vue';
import { ArrowRightIcon } from '@heroicons/vue/24/outline';
import Container from '@/components/ui/Container.vue';
import SectionHeading from '@/components/ui/SectionHeading.vue';
import { getFeaturedProducts } from '@/services/productService';

const courses = ref([]);

const fallbackImages = [
    'images/courses/quran.jpg',
    'images/courses/tafl.jpg',
    'images/courses/arabic.jpg',
    'images/courses/islamic.jpg',
];

onMounted(() => {
    getFeaturedProducts().then((response) => {
        courses.value = response.data;
    }).catch((error) => {
        console.error('Error fetching featured courses:', error);
    });
});
</script>
